// ExportModal.tsx
import { Checkbox, Col, Modal, Row, Space } from "antd"; // Remove Form import
import { CommonButton } from "../../CommonButton/button";
import "./ExportModal.css";

interface ExportModalProps {
  isModalOpen: boolean;
  handleCancel: () => void;
  title?: string;

  columnOptions: { dataIndex: string; title: string; key?: string }[];
  selectedColumns: Record<string, boolean>;
  setSelectedColumns: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;

  children?: React.ReactNode;

  handleDownload: () => void;
  isExporting: boolean;
  downloadButtonText?: string;
}

const ExportModal = ({
  isModalOpen,
  handleCancel,
  title = "Export Data",
  columnOptions,
  selectedColumns,
  setSelectedColumns,
  children,
  handleDownload,
  isExporting,
  downloadButtonText = "Download",
}: ExportModalProps) => {
  const isManager = localStorage.getItem("user_role");

  const filteredColumnOptions = columnOptions.filter((col) => {
    if (col.dataIndex === "executive_name" && isManager !== "1") {
      return false;
    }
    return true;
  });

  return (
    <Modal
      title="Export Data"
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
    >
      <div className="export-modal-container">
        {/* Module Display */}
        <Row className="export-modal-row">
          <Col span={6}>
            <strong>Module:</strong>
          </Col>
          <Col span={18}>
            <div className="export-modal-module-box">{title}</div>
          </Col>
        </Row>

        {/* Dynamic Filters */}
        {children && <div className="export-modal-children">{children}</div>}

        {/* Included Columns Section */}
        <div className="export-modal-columns">
          <strong className="export-modal-columns-title">
            Included Columns:
          </strong>

          <Space size="large" wrap>
            {filteredColumnOptions.map((col) => (
              <Checkbox
                key={col.dataIndex}
                checked={selectedColumns[col.dataIndex]}
                onChange={(e) =>
                  setSelectedColumns({
                    ...selectedColumns,
                    [col.dataIndex]: e.target.checked,
                  })
                }
              >
                {col.title}
              </Checkbox>
            ))}
          </Space>
        </div>

        {/* Footer Buttons */}
        <div className="export-modal-footer">
          <CommonButton
            variant="wealay-secondary-btn"
            className="customer-preview-h1"
            value="Cancel"
            onClick={handleCancel}
            type="button"
          />

          <CommonButton
            variant="wealay-primary-btn"
            className="sales-detail-btn-clr w-content"
            value={isExporting ? "Exporting..." : downloadButtonText}
            disabled={isExporting}
            onClick={handleDownload}  
          />
        </div>
      </div>
    </Modal>
  );
};

export default ExportModal;